class CustomStickyAddToCart {
  constructor() {
    this.initStickyAddToCart();
  }

  initStickyAddToCart() {
    const productPage = document.querySelector('product-page');
    if (productPage) {
      productPage.addEventListener('VARIANT_CHANGE', this.updateStickyCart.bind(this));
    }

    const addToCartButton = document.querySelector('.sticky-add-to-cart .add-to-cart-button');
    if (addToCartButton) {
      addToCartButton.addEventListener('click', this.addToCart.bind(this));
    }
  }

  updateStickyCart(event) {
    const variant = event.detail.variant;
    const priceSection = document.querySelector('.sticky-add-to-cart .price-section');
    
    if (variant && priceSection) {
      priceSection.querySelector('.discounted-price').textContent = variant.price;
      priceSection.querySelector('.original-price').textContent = variant.compare_at_price || '';
      priceSection.querySelector('.you-save').textContent = variant.compare_at_price ? `risparmi ${variant.compare_at_price - variant.price}` : '';
    }
  }

  addToCart() {
    const formElement = document.querySelector('form[data-js-product-form]');
    if (formElement) {
      formElement.dispatchEvent(new Event('submit'));
      setTimeout(() => {
        document.getElementById('site-cart-sidebar').show();
      }, 500); // Adjust delay as necessary for your theme
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CustomStickyAddToCart();
});
